import api from '../axiosConfig';
import { RESERVATIONS } from '../config/apiEndpoints';

export const ReservationService = {
    getAll: async (params = {}, tenantId) => {
        try {
            const axiosParams = {};
            if (params.page !== undefined) {
                axiosParams.page = params.page;
            } else if (params.noPagination || params.noPaging) {
                axiosParams.noPagination = true;
            } else {
                axiosParams.noPagination = true;
            }
            if (params.limit !== undefined) axiosParams.limit = params.limit;
            if (params.status && params.status !== 'All') axiosParams.status = params.status;
            if (params.bookingType && params.bookingType !== 'All') axiosParams.bookingType = params.bookingType;
            if (params.channel && params.channel !== 'All') axiosParams.channel = params.channel;
            if (params.source && params.source !== 'All') axiosParams.source = params.source;
            if (params.roomType && params.roomType !== 'All') axiosParams.roomType = params.roomType;
            if (params.paymentStatus && params.paymentStatus !== 'All') axiosParams.paymentStatus = params.paymentStatus;
            if (params.checkInFrom || params.checkinFrom) axiosParams.checkInFrom = params.checkInFrom || params.checkinFrom;
            if (params.checkInTo || params.checkinTo) axiosParams.checkInTo = params.checkInTo || params.checkinTo;
            if (params.checkOutFrom || params.checkoutFrom) axiosParams.checkOutFrom = params.checkOutFrom || params.checkoutFrom;
            if (params.checkOutTo || params.checkoutTo) axiosParams.checkOutTo = params.checkOutTo || params.checkoutTo;
            if (params.search) axiosParams.search = params.search;

            const response = await api.get(RESERVATIONS.BASE, {
                params: axiosParams,
                headers: { 'x-tenant-id': tenantId }
            });
            return response.data;
        } catch (error) {
            console.error('ReservationService getAll error:', error);
            throw error;
        }
    },
    create: async (payload, tenantId) => {
        try {
            const response = await api.post(RESERVATIONS.BASE, payload, {
                headers: { 'x-tenant-id': tenantId }
            });
            return response.data;
        } catch (error) {
            console.error('ReservationService create error:', error);
            throw error;
        }
    },
    createGroup: async (payload, tenantId) => {
        try {
            const response = await api.post(RESERVATIONS.GROUP, payload, {
                headers: { 'x-tenant-id': tenantId }
            });
            return response.data;
        } catch (error) {
            console.error('ReservationService createGroup error:', error);
            throw error;
        }
    },
    getCalendar: async (startDate, endDate, tenantId) => {
        try {
            const response = await api.get(RESERVATIONS.CALENDAR, {
                params: { startDate, endDate },
                headers: { 'x-tenant-id': tenantId }
            });
            return response.data;
        } catch (error) {
            console.error('ReservationService getCalendar error:', error);
            throw error;
        }
    },
    getById: async (id, tenantId) => {
        try {
            const response = await api.get(RESERVATIONS.BY_ID(id), {
                headers: { 'x-tenant-id': tenantId }
            });
            return response.data;
        } catch (error) {
            console.error('ReservationService getById error:', error);
            throw error;
        }
    },
    getGroupDetail: async (groupId, tenantId) => {
        try {
            const response = await api.get(`${RESERVATIONS.GROUP}/${groupId}`, {
                headers: { 'x-tenant-id': tenantId }
            });
            return response.data;
        } catch (error) {
            console.error('ReservationService getGroupDetail error:', error);
            throw error;
        }
    },
    moveRoom: async (reservationId, tenantId, payload) => {
        try {
            const response = await api.patch(RESERVATIONS.MOVE_ROOM(reservationId), payload, {
                headers: { 'x-tenant-id': tenantId }
            });
            return response.data;
        } catch (error) {
            console.error('ReservationService moveRoom error:', error);
            throw error;
        }
    },
    update: async (id, tenantId, payload) => {
        try {
            const response = await api.put(RESERVATIONS.BY_ID(id), payload, {
                headers: { 'x-tenant-id': tenantId }
            });
            return response.data;
        } catch (error) {
            console.error('ReservationService update error:', error);
            throw error;
        }
    },
    approveGovernmentClearance: async (id, tenantId, payload = {}) => {
        try {
            const body = {
                approvalReference: payload?.approvalReference || 'DET-2026-98124',
                notes: payload?.notes || 'Verified and cleared with Dubai Police / DET portal'
            };
            const response = await api.post(RESERVATIONS.APPROVE_GOVERNMENT(id), body, {
                headers: { 'x-tenant-id': tenantId }
            });
            return response.data;
        } catch (error) {
            console.error('ReservationService approveGovernmentClearance error:', error);
            throw error;
        }
    },
    cancel: async (id, tenantId, payload) => {
        try {
            const response = await api.patch(RESERVATIONS.CANCEL(id), payload, {
                headers: { 'x-tenant-id': tenantId }
            });
            return response.data;
        } catch (error) {
            console.error('ReservationService cancel error:', error);
            throw error;
        }
    },
    checkIn: async (id, tenantId) => {
        try {
            const response = await api.patch(`${RESERVATIONS.BASE}/${id}/check-in`, {}, {
                headers: { 'x-tenant-id': tenantId }
            });
            return response.data;
        } catch (error) {
            console.error('ReservationService checkIn error:', error);
            throw error;
        }
    },
    checkOut: async (id, tenantId) => {
        try {
            const response = await api.patch(`${RESERVATIONS.BASE}/${id}/check-out`, {}, {
                headers: { 'x-tenant-id': tenantId }
            });
            return response.data;
        } catch (error) {
            console.error('ReservationService checkOut error:', error);
            throw error;
        }
    },
    markNoShow: async (id, tenantId) => {
        try {
            const response = await api.patch(RESERVATIONS.NO_SHOW(id), {}, {
                headers: { 'x-tenant-id': tenantId }
            });
            return response.data;
        } catch (error) {
            console.error('ReservationService markNoShow error:', error);
            throw error;
        }
    },
    processRefund: async (id, tenantId, payload) => {
        try {
            const response = await api.post(RESERVATIONS.REFUND(id), payload, {
                headers: { 'x-tenant-id': tenantId }
            });
            return response.data;
        } catch (error) {
            console.error('ReservationService processRefund error:', error);
            throw error;
        }
    },
    exportReport: async (params, tenantId) => {
        try {
            const response = await api.get(RESERVATIONS.EXPORT, {
                params,
                headers: { 'x-tenant-id': tenantId }
            });
            return response;
        } catch (error) {
            console.error('ReservationService exportReport error:', error);
            throw error;
        }
    },
    getRateOverrides: async (tenantId, params = {}) => {
        try {
            let actualTenantId = tenantId;
            let actualParams = params;
            if (typeof tenantId === 'object' && tenantId !== null) {
                actualParams = tenantId;
                actualTenantId = params;
            }
            const axiosParams = {};
            if (actualParams.page !== undefined) {
                axiosParams.page = actualParams.page + 1;
            }
            if (actualParams.limit !== undefined) {
                axiosParams.limit = actualParams.limit;
            }
            const response = await api.get(RESERVATIONS.RATE_OVERRIDES, {
                params: axiosParams,
                headers: actualTenantId ? { 'x-tenant-id': actualTenantId } : {}
            });
            return response.data;
        } catch (error) {
            console.error('ReservationService getRateOverrides error:', error);
            throw error;
        }
    },
    approveRateOverride: async (id, tenantId) => {
        try {
            const response = await api.post(RESERVATIONS.APPROVE_RATE_OVERRIDE(id), {}, {
                headers: { 'x-tenant-id': tenantId }
            });
            return response.data;
        } catch (error) {
            console.error('ReservationService approveRateOverride error:', error);
            throw error;
        }
    },
    rejectRateOverride: async (id, payload, tenantId) => {
        try {
            const response = await api.post(RESERVATIONS.REJECT_RATE_OVERRIDE(id), payload, {
                headers: { 'x-tenant-id': tenantId }
            });
            return response.data;
        } catch (error) {
            console.error('ReservationService rejectRateOverride error:', error);
            throw error;
        }
    }
};
